import {
  ACTIVE,
  ACTIVE_USERS_ONLY,
  CHANGE_USER_STATUS_DIALOG,
  changeSortingProperties,
  cleanUserData,
  CREATE_NEW_USER_DIALOG,
  createNewUser,
  CURRENT_PASSWORD_IS_VALID,
  CURRENT_USERNAME_IS_VALID,
  EDIT_USER_DIALOG,
  editUser,
  FIRSTNAME,
  functionSwitchPage,
  LASTNAME,
  loadAvailableRoles,
  LOADED,
  loadMasterData,
  loadUserPermissionHistory,
  loadUsers,
  LOCAL_ROLES,
  moveRole,
  NUMBER_OF_USERS_PER_PAGE,
  onHandleFirst,
  onHandleLast,
  onHandleNext,
  onHandlePrev,
  PAGINATION_LINKS,
  PASSWORD,
  prepareUserDataForEditing,
  propertyChange,
  ROLE_LIST,
  SEND_USER_NOTIFICATION,
  sendUserAccountNotification,
  SORT_USER_TABLE_BY,
  SORT_USER_TABLE_ORDER,
  UNNOTIFIED_USERS_ONLY,
  USER_ALREADY_EXISTS,
  USER_PARTICIPATIONS,
  USER_PARTICIPATIONS_BY_USER,
  USER_PERMISSION_HISTORY,
  USER_PERMISSION_HISTORY_LOADING,
  USER_ROLES,
  USER_TABLE_PAGE,
  USERNAME,
  EMPLOYEE_NUMBER,
  USERS
} from "../../../ducks/userManagement";
import { FUNDING_AREA_LIST, setFilters } from "../../../ducks/fundingArea";

import { LANGUAGE } from "../../../ducks/languageSelector";
import { ROLES } from "../../../ducks/login";
import UserManagement from "./UserManagement";
import { bindActionCreators } from "redux";
import { clearMessages } from "../../../ducks/message";
import { connect } from "react-redux";
import { FUNDING_AREA_STORE, LANGUAGE_SELECTOR, LOGIN_STORE, USER_MANAGEMENT_STORE } from "../../../common/constant";

const mapStateToProps = (state) => {
  const userMgnt = state[USER_MANAGEMENT_STORE];

  return {
    paginationLinks: userMgnt[PAGINATION_LINKS],
    users: userMgnt[USERS],
    usersParticipations: userMgnt[USER_PARTICIPATIONS_BY_USER],
    userTablePage: userMgnt[USER_TABLE_PAGE],
    createNewUserDialog: userMgnt[CREATE_NEW_USER_DIALOG],
    username: userMgnt[USERNAME],
    firstname: userMgnt[FIRSTNAME],
    lastname: userMgnt[LASTNAME],
    employeeNumber: userMgnt[EMPLOYEE_NUMBER],
    password: userMgnt[PASSWORD],
    sendUserNotification: userMgnt[SEND_USER_NOTIFICATION],
    editUserDialog: userMgnt[EDIT_USER_DIALOG],
    changeUserStatusDialog: userMgnt[CHANGE_USER_STATUS_DIALOG],
    active: userMgnt[ACTIVE],
    sortUserTableBy: userMgnt[SORT_USER_TABLE_BY],
    sortUserTableOrder: userMgnt[SORT_USER_TABLE_ORDER],
    userAlreadyExists: userMgnt[USER_ALREADY_EXISTS],
    currentPasswordIsValid: userMgnt[CURRENT_PASSWORD_IS_VALID],
    currentUsernameIsValid: userMgnt[CURRENT_USERNAME_IS_VALID],
    localRoles: userMgnt[LOCAL_ROLES],
    user_roles: userMgnt[USER_ROLES],
    numberOfUserPerPage: userMgnt[NUMBER_OF_USERS_PER_PAGE],
    activeOnly: userMgnt[ACTIVE_USERS_ONLY],
    unnotifiedUsersOnly: userMgnt[UNNOTIFIED_USERS_ONLY],
    userParticipations: userMgnt[USER_PARTICIPATIONS],
    userPermissionHistory: userMgnt[USER_PERMISSION_HISTORY],
    userPermissionHistoryLoading: userMgnt[USER_PERMISSION_HISTORY_LOADING],
    loaded: userMgnt[LOADED],
    roleList: userMgnt[ROLE_LIST],
    fundingAreaList: state[FUNDING_AREA_STORE][FUNDING_AREA_LIST].userManagament || [],

    roles: state[LOGIN_STORE][ROLES],
    locale: state[LANGUAGE_SELECTOR][LANGUAGE]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadUsers,
      propertyChange,
      createNewUser,
      prepareUserDataForEditing,
      editUser,
      cleanUserData,
      clearMessages,
      onHandleFirst,
      onHandleLast,
      onHandleNext,
      onHandlePrev,
      functionSwitchPage,
      loadAvailableRoles,
      moveRole,
      changeSortingProperties,
      loadMasterData,
      loadUserPermissionHistory,
      setFilters,
      sendUserAccountNotification
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
